// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Aedu.ExternalLinkRecommendation = createReactClass({
    propTypes: {
      source: PropTypes.string.isRequired, // Must be from the source enum in Certification
    },

    getInitialState: function() {
      return {
        inputUrl: '',
        valid: true
      };
    },

    updateInputUrl: function(evt) {
      this.setState({
        inputUrl: evt.target.value
      });
    },

    showExternalCertifyModal: function(evt) {
      evt.preventDefault();
      var input = this.inputField;
      if(input.validity === undefined || input.validity.valid) {
        this.setState({valid: true});
        var params = {
          url: this.state.inputUrl,
          source: this.props.source,
          onCertify: function(){input.value = "";}
        };
        Components.Utils.showModal(Certifications.Modals.CertificationModal, params);
      } else {
        this.setState({valid: false});
      }
    },

    invalidText: function() {
      return (
        <span className='u-fs12 u-fw500 u-tcRed'>Invalid URL</span>
      );
    },

    render: function() {
      var inputClasses = classNames({
        "TextInput": true,
        "TextInput--md": true,
        "TextInput--dark": true,
        "WithIcon": true,
        "TextInput--error": !this.state.valid
      });
      var validText = this.state.valid ? "" : this.invalidText()
      return (
        <div>
          {validText}
          <form>
            <button className=
              "Button Button--md Button--inverseGreen u-floatRight u-ml4x"
              type="submit" onClick={this.showExternalCertifyModal}>
              Recommend
            </button>
            <div className="TextInputWrapper--icon u-overflowHidden">
              <input
                className={inputClasses}
                placeholder="Post a link to any paper (on or off Academia)"
                value={this.state.inputUrl}
                onChange={this.updateInputUrl}
                type="text"
                inputMode="url"
                pattern="((http|https):\/\/)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)"
                ref={function(ref){this.inputField = ref}.bind(this)}
                required></input>
              <i className="fa fa-link u-tcGrayDark u-fw700 TextInputIcon"></i>
            </div>
          </form>
        </div>
      );
    },
  });
})();
